export const isEnabled = (value) => value === true || value === 1;

export function buildPermissionTree(views) {
  const nodes = new Map();
  views.forEach((view) => {
    if (!nodes.has(view.key)) nodes.set(view.key, { ...view, children: [] });
  });
  const roots = [];
  nodes.forEach((node) => {
    const parent = nodes.get(node.parentKey);
    if (parent && parent !== node) parent.children.push(node);
    else roots.push(node);
  });
  return { roots, nodes };
}

export const branchNodes = (node) => [node, ...node.children.flatMap(branchNodes)];
export const leafNodes = (node) =>
  node.children.length ? node.children.flatMap(leafNodes) : [node];

export function selectionState(node, permissions) {
  const values = branchNodes(node).map((item) => isEnabled(permissions[item.key]));
  const checked = values.every(Boolean);
  return { checked, indeterminate: !checked && values.some(Boolean) };
}

// Los antecesores se recalculan con la selección nueva, sin lecturas atrasadas del formulario.
export function togglePermission(permissions, key, tree) {
  const node = tree.nodes.get(key);
  if (!node) return permissions;
  const next = { ...permissions };
  const enabled = !selectionState(node, permissions).checked;
  branchNodes(node).forEach((item) => {
    next[item.key] = enabled;
  });
  let parent = tree.nodes.get(node.parentKey);
  while (parent) {
    next[parent.key] = parent.children.some((child) =>
      branchNodes(child).some((item) => isEnabled(next[item.key]))
    );
    parent = tree.nodes.get(parent.parentKey);
  }
  return next;
}

export function permissionCounts(node, permissions) {
  const leaves = leafNodes(node);
  return {
    selected: leaves.filter((item) => isEnabled(permissions[item.key])).length,
    total: leaves.length,
  };
}

export const searchableName = (name) =>
  String(name)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

export function matchesPermission(node, query, selectedOnly, permissions, ancestorMatches = false) {
  const matchesName =
    ancestorMatches || !query || searchableName(node.name).includes(searchableName(query));
  if (matchesName && (!selectedOnly || isEnabled(permissions[node.key]))) return true;
  return node.children.some((child) =>
    matchesPermission(child, query, selectedOnly, permissions, matchesName)
  );
}

export function permissionChanges(original, current, tree) {
  return [...new Set([...Object.keys(original), ...Object.keys(current)])]
    .filter((key) => isEnabled(original[key]) !== isEnabled(current[key]))
    .map((key) => ({
      key,
      name: tree.nodes.get(key)?.name || key,
      enabled: isEnabled(current[key]),
    }));
}
